import FailedSVG from './components/FailedSvg'
import backgroundImage from '../../../assets/background.jpg'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export default function PaymentFailedScreen() {
  const navigate = useNavigate()

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate('/login')
    }, 5000)

    return () => clearTimeout(timeout)
  }, [navigate])

  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center px-4"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}>
      <div className="mt-4 flex flex-col items-center justify-center">
        <FailedSVG />
        <h1 className="mt-4 text-center text-2xl font-semibold text-red-600">
          Payment Failed
        </h1>
        <p className="mt-2 text-center text-lg font-medium text-green-600">
          But your registration was successful!
        </p>
      </div>

      <div className="mt-6 max-w-md px-4 text-center text-[0.95rem] text-gray-800">
        <p>
          You can log in to your account and add a payment method at any time to
          activate your services.
        </p>
        <p className="mt-4">
          If you wish to enable Facial Recognition Payment in future, please
          check the box
          <br />
          <strong>'Save my cards for the next purchase'</strong> on the next
          Razer Merchant Services page.
        </p>
      </div>

      <div className="mt-8 flex gap-4">
        <button
          type="button"
          className="w-36 rounded-2xl bg-[#5CB891] px-8 py-2 font-semibold text-white"
          onClick={() => navigate('/')}>
          Log In
        </button>
        <button
          type="button"
          className="w-36 rounded-2xl border-2 border-[#5CB891] bg-white px-8 py-2 font-semibold text-[#5CB891]">
          Retry Payment
        </button>
      </div>
    </div>
  )
}
